import React from 'react'
import { useSelector } from 'react-redux'
import { IStore } from '../reducers'

function useSize(view: SizeViewType = 'forms') {
  return useSelector((state: IStore) => state.bookingCalendar.size[view] || 1)
}

function withSize(C, view: SizeViewType = 'forms') {
  return function(props) {
    const size = useSize(view)
    return <C {...props} size={size}/>
  }
}

export default useSize
export { withSize }
export type SizeViewType = 'calendar' | 'forms' | 'settings' | 'profile'
